// Copyright (c) 2018 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import FormFields from './form-fields';
import InstructionsPanels from './instructions-panels';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import RequestDetailsHeader from './request-details-header';
import RequestInformationPanel from './request-information-panel';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

class RequestDetails extends Component {

    componentWillMount() {

        this.props.actions.readRequestDetails(this.props.queryParams.id);

    }

    componentWillUnmount() {

        this.props.actions.resetRequestDetails();

    }

    render() {

        return (
            <section className='request-details'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <RequestDetailsHeader
                    language={this.props.user.getLocale()}
                    partReturn={this.props.partReturn}
                />
                <main>
                    <RequestInformationPanel partReturn={this.props.partReturn}/>
                    <InstructionsPanels/>
                    <FormFields/>
                </main>
            </section>
        );

    }

}

RequestDetails.displayName = 'RequestDetails';
RequestDetails.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    partReturn: PropTypes.instanceOf(PartReturn).isRequired,
    queryParams: PropTypes.object.isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default RequestDetails;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/index.js